/**
 * Get the corresponding pageName property based on the current route.
 * @param {string} pathname
 * @returns {string} pageName
 */
const getPageName = (pathname) => {
  const lastString = pathname.substring(pathname.lastIndexOf('/') + 1);
  const pageTitle = lastString === '$uuid' ? getPageName(pathname.substring(0, pathname.lastIndexOf('/'))) : lastString;
  return pageTitle === 'company' ? 'dashboard-homepage' : pageTitle;
};

export default getPageName;
